// Stabiler Idempotenz-Schlüssel für schreibende Mutationen (zugleich serverseitiger client_uuid).
// Bevorzugt die Web-Crypto-UUID; fällt nur in sehr alten/eingeschränkten Umgebungen zurück.
export function newUuid(): string {
  const c: Crypto | undefined = globalThis.crypto
  if (c && typeof c.randomUUID === 'function') return c.randomUUID()
  return `uuid-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`
}
